import { getCookie } from '../CookieUtil';
import { langIdOnLocale } from '../LocaleUtil/languageList';

function getIdsForDataLayer(idName) {
    const id = getCookie(idName);
    return id || '';
}

function getIpAddressAndIsEuCheck() {
    return fetch('https://bridge.expediapartnercentral.com/location/', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => response.json())
        .then((data) => data);
}

function initGTMData(data) {
    window.dataLayer.push({
        // Page details
        applicationName: 'eg-partner-qualifier', // Application name (epc-onboarding-web)
        applicationEnvironment: window.analyticsdatalayer.appenvironment,
        locale: window.analyticsdatalayer.displaylocale, // locale
        GAID: getIdsForDataLayer('_gid'),
        GUID: getIdsForDataLayer('MC1').split('GUID=')[1],
        DUAID: getIdsForDataLayer('DUAID'),
        JSessionID: getIdsForDataLayer('ulxsession'),
        languageID: langIdOnLocale(window.analyticsdatalayer.displaylocale),
        ...data
    });
}

function pushGTMDataPageLoad(pageName, event, ApplicationID) {
    getIpAddressAndIsEuCheck().then((data) => {
        if (typeof data.location.is_eu !== 'undefined' && typeof data.location.is_eu === 'boolean') {
            initGTMData({
                ipAddress: data.ip,
                isEU: data.location.is_eu ? 1 : 0,
                pageName,
                event,
                ApplicationID
            });
        } else {
            initGTMData({
                ipAddress: data.ip,
                isEU: 0,
                pageName,
                event,
                ApplicationID
            });
        }
    }).catch(() => {
        initGTMData({
            ipAddress: '',
            isEU: 0,
            pageName,
            event,
            ApplicationID
        });
    });
}

function pageLoad(payload) {
    const { pageName, event, ApplicationID } = payload;
    if (typeof window === 'object' && window.dataLayer) {
        if (window.dataLayer.length <= 2) {
            pushGTMDataPageLoad(pageName, event, ApplicationID);
        } else {
            window.dataLayer.push({
                pageName,
                event,
                ApplicationID
            });
        }
    }
}

function gtmDataPush(data) {
    if (typeof window === 'object' && window.dataLayer) {
        window.dataLayer.push(data);
    }
}

function pageUnload() {

}

export default {
    pageLoad, gtmDataPush, pageUnload
};
